// StakingTask.jsx
import React, { useState } from "react";
import { FaCheck, FaInfoCircle, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { createPublicClient, http } from "viem";
import { mainnet } from "viem/chains";
import { erc20Abi } from "viem";
import { httpReauest } from "../../utils/httpRequest";

const TOKEN_ADDRESS = "0x26431f855b1e8C7F4ab1851a7A09AaB72d76252d"; // ← آدرس ERC-20
const publicClient = createPublicClient({
  chain: mainnet, // یا chain مورد نظر شما مثل polygon, optimism
  transport: http(),
});

const StakingTask = ({ user, reward, getData }) => {
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const [checking, setChecking] = useState(false);

  const handleStartClick = () => {
    window.open("https://buy.filetrust.io", "_blank");
  };

  const handleCheck = async () => {
    try {
      if (!user?._id) return toast.error("User not found.");
      if (!user?.wallet) return toast.info("No wallet linked in your profile.");

      setChecking(true);

      // 1) read decimals + balanceOf با viem
      const [decimals, rawBal] = await Promise.all([
        publicClient.readContract({
          address: TOKEN_ADDRESS,
          abi: erc20Abi,
          functionName: "decimals",
        }),
        publicClient.readContract({
          address: TOKEN_ADDRESS,
          abi: erc20Abi,
          functionName: "balanceOf",
          args: [user.wallet],
        }),
      ]);

      const hasTokens = (rawBal ?? 0n) > 0n;
      const human = Number(rawBal) / 10 ** Number(decimals);
      const userStorage = JSON.parse(localStorage.getItem("user"));

      if (!hasTokens) {
        toast.warn("No FileTrust tokens found in your registered wallet.");
        return;
      }

      // 2) claim اتمیک در بک‌اند (پاداش فقط یک‌بار داده می‌شود)

      await httpReauest(
        "POST",
        "/user/staking",
        { },
        { "x-access-token": userStorage?.token }
      );

      getData && getData();
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div
      className={`${
        user?.staking && "order-last opacity-40"
      } flex justify-between gap-3 items-center relative border-b py-2 pb-4 text-white`}
    >
      <span className="flex items-center gap-2 lg:gap-4">
        <img
          src="https://www.filetrust.io/img/Logo_white.svg"
          className="w-8 lg:w-14"
          alt="Logo"
        />
        <span>
          <h4 className="font-bold text-[14px] lg:text-[28px] lg:-mb-2 flex items-center gap-2">
            Stake FileTrust Token
            <FaInfoCircle
              className="text-blue-400 cursor-pointer"
              onClick={() => setIsHelpOpen(true)}
              title="Help"
            />
          </h4>
          <span className="font-bold text-[16px] lg:text-[28px] flex gap-1 items-center">
            <img src="/gold.png" className="w-6 lg:w-8" alt="GOLD" />+{reward}
          </span>
        </span>
      </span>

      {user?.staking ? (
        <button
          disabled
          className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
        >
          <FaCheck color="green" /> Claimed
        </button>
      ) : (
        <div className="flex gap-2">
          <button
            onClick={handleStartClick}
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px]"
          >
            Start
          </button>
          <button
            onClick={handleCheck}
            disabled={checking}
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px]"
          >
            {checking ? "Checking..." : "Check"}
          </button>
        </div>
      )}

      {isHelpOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
          <div className="bg-[#1e293b] rounded-xl max-w-[90%] w-full sm:w-[400px] p-4">
            <div className="flex justify-between items-center mb-4 text-white">
              <h2 className="text-xl font-bold ">How This Task Works</h2>
              <button
                onClick={() => setIsHelpOpen(false)}
                className="text-lg font-bold"
              >
                <FaTimes />
              </button>
            </div>
            <p className="text-gray-100 text-left">
              Make sure your profile has your wallet address. Click <b>Start</b>{" "}
              to get FileTrust tokens, then click <b>Check</b>. If tokens are
              found in your registered wallet, the reward will be added
              automatically.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default StakingTask;
